import {
  profile,
  bank,
  card,
  preference,
  help,
  faq,
  earn,
  privacy,
  logout,
} from 'src/assets'

interface Data {
  id: string
  SettingTitle: string
  SettingsDescription: string
  icon: any
  path: string
  target?: string
  class?: any
}

export const SettingsPageData: Data[] = [
  {
    id: '1',
    SettingTitle: 'Profile Information',
    SettingsDescription: 'Edit your profile information',
    icon: profile,
    path: '/profiles',
    class: 'profile-data',
  },
  {
    id: '2',
    SettingTitle: 'Bank Information',
    SettingsDescription: 'Add and remove bank accounts',
    path: '/bank-detail-page',
    icon: bank,
    class: 'bank',
  },
  // {
  //   id: '2',
  //   SettingTitle: 'Bank Settings',
  //   SettingsDescription: 'Add and remove bank accounts',
  //   icon: SettingsBank,
  //   path: '/bank-setting',
  // },
  {
    id: '3',
    SettingTitle: 'Card Information',
    SettingsDescription: 'Add and remove bank cards',
    icon: card,
    path: '/card-setting',
    class: 'card',
  },
  {
    id: '4',
    SettingTitle: 'Preferences',
    SettingsDescription: 'Privacy',
    icon: preference,
    path: '/preference',
    class: 'preference',
  },
  {
    id: '5',
    SettingTitle: 'Help',
    SettingsDescription: 'Make a complaint',
    icon: help,
    path: '/help',
    class: 'help',
  },
  {
    id: '6',
    SettingTitle: 'FAQ',
    SettingsDescription: 'Popular questions and answers',
    icon: faq,
    path: '/faqs',
    class: 'faq',
  },
  {
    id: '7',
    SettingTitle: 'Earn',
    SettingsDescription: 'Get payed for inviting your friends',
    icon: earn,
    path: '/earn',
    class: 'earn',
  },
]
export const SettingsLogoutData: Data[] = [
  {
    id: '10',
    SettingTitle: 'Log Out',
    SettingsDescription: '',
    icon: logout,
    path: '/logout',
    class: 'logout',
  },
]
export const PrivacyPolicyData: Data[] = [
  {
    id: '9',
    SettingTitle: 'Privacy Policy',
    SettingsDescription: 'Generate Lorem Ipsum place',
    icon: privacy,
    path: 'https://fandksavings.com/privacy',
    target: '_blank',
    class: 'privacy',
  },
]
